// extracted by mini-css-extract-plugin
module.exports = {"echodot":"echodottop_echodot__ZLRMy"};